import React, { useEffect, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import logo from '../../assets/img/reactlogo.png';
import logoSmall from '../../assets/img/logoSmall.png';
import '../../assets/css/flaticon.css';
import bazaarLogo from '../../assets/img/bazaarLogo.png';
import { useSelector, useDispatch } from "react-redux";
import { setData } from "../../redux/actions";
import $ from 'jquery';
import { ToastContainer } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faLayerGroup, faCartShopping, faHeart, faUser } from '@fortawesome/free-solid-svg-icons';

// Attach jQuery to the global window object
window.jQuery = $;
window.$ = $;

function BazaarLayout() {
  const dispatch = useDispatch();
  const [canvas, setCanvas] = useState(false);
  const [cart, setCart] = useState([]);
  let cartRaw = useSelector((state) => state.data?.cart);

  useEffect(() => {
    let cart1 = localStorage.getItem('cart');
    dispatch(setData({ cart: cart1 }));
  }, []);

  useEffect(() => {
    let parsedCart = [];
    if (typeof cartRaw === "string") {
      try {
        parsedCart = JSON.parse(cartRaw);
      } catch (e) {
        console.error("Invalid JSON in cartRaw:", cartRaw);
      }
    }
    setCart(parsedCart);
  }, [cartRaw]);

  return (
    <>
      {/* <div id="preloder">
        <div class="loader"></div>
      </div> */}
      <div class={`offcanvas-menu-overlay ${canvas ? "active" : ""}`} onClick={(e) => setCanvas(false)}></div>
      <div class={`offcanvas-menu-wrapper ${canvas ? "active" : ""}`}>
        <div class="offcanvas__close" onClick={(e) => setCanvas(false)}>+</div>
        <ul class="offcanvas__widget">
          <li><span class="icon_search search-switch"></span></li>
          <li><a href="#"><span class="icon_heart_alt"></span>
            <div class="tip">0</div>
          </a></li>
          <li><Link to="/bazaar/cart"><span class="icon_bag_alt"></span>
            <div class="tip">{cart.length}</div>
          </Link></li>
        </ul>
        <div class="offcanvas__logo">
          <Link to="/"><img src={bazaarLogo} alt="" /></Link>
        </div>
        <div id="mobile-menu-wrap">
          <div class="slicknav_menu">
            <nav class="slicknav_nav slicknav_hidden" aria-hidden="true" role="menu">
              <ul>
                <li><Link to={"/bazaar"} role="menuitem" onClick={(e) => setCanvas(false)}>Home</Link></li>
                <li><Link to="/bazaar/shop" role="menuitem" onClick={(e) => setCanvas(false)}>Shop</Link></li>
                <li><Link to="/bazaar/cart" role="menuitem" onClick={(e) => setCanvas(false)}>Cart</Link></li>
                <li><Link to="/bazaar/checkout" role="menuitem" onClick={(e) => setCanvas(false)}>Checkout</Link></li>
              </ul>
            </nav>
          </div>
        </div>
        {/* <div class="offcanvas__auth">
          <a href="#">Login</a>
          <a href="#">Register</a>
        </div> */}
      </div>
      <header class="header">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-3 col-lg-2">
              <div class="header__logo">
                <Link to="/bazaar"><img src={bazaarLogo} alt="" /></Link>
              </div>
            </div>
            <div class="col-xl-6 col-lg-7">
              <nav class="header__menu">
                <ul>
                  <li class="active"><Link to="/bazaar">Home</Link></li>
                  <li><Link to="/bazaar/shop">Shop</Link></li>
                  <li><Link to="/bazaar/cart">Cart</Link></li>
                  <li><Link to="/bazaar/checkout">Checkout</Link></li>
                  <li><Link to="#">Contact</Link></li>
                </ul>
              </nav>
            </div>
            <div class="col-lg-3">
              <div class="header__right">
                {/* <div class="header__right__auth">
                  <Link to="/login">Login</Link>
                  <Link to="/register">Register</Link>
                </div> */}
                <ul class="header__right__widget">
                  <li><span class="icon_search search-switch"></span></li>
                  <li><a href="#"><span class="icon_heart_alt"></span>
                    <div class="tip">0</div>
                  </a></li>
                  <li><Link to="/bazaar/cart"><span class="icon_bag_alt"></span>
                    <div class="tip">{cart.length}</div>
                  </Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="canvas__open" onClick={(e) => setCanvas(!canvas)}>
            <i class="fa fa-bars"></i>
          </div>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      {/* <div class="instagram">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-2 col-md-4 col-sm-4 p-0">
              <div class="instagram__item set-bg" style={{ backgroundImage: `url('/theme/ashion/img/instagram/insta-1.jpg')` }} data-setbg="img/instagram/insta-1.jpg">
                <div class="instagram__text">
                  <i class="fa fa-instagram"></i>
                  <a href="#">@ ashion_shop</a>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-4 p-0">
              <div class="instagram__item set-bg" style={{ backgroundImage: `url('/theme/ashion/img/instagram/insta-2.jpg')` }} data-setbg="img/instagram/insta-2.jpg">
                <div class="instagram__text">
                  <i class="fa fa-instagram"></i>
                  <a href="#">@ ashion_shop</a>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-4 p-0">
              <div class="instagram__item set-bg" style={{ backgroundImage: `url('/theme/ashion/img/instagram/insta-3.jpg')` }} data-setbg="img/instagram/insta-3.jpg">
                <div class="instagram__text">
                  <i class="fa fa-instagram"></i>
                  <a href="#">@ ashion_shop</a>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-4 p-0">
              <div class="instagram__item set-bg" style={{ backgroundImage: `url('/theme/ashion/img/instagram/insta-4.jpg')` }} data-setbg="img/instagram/insta-4.jpg">
                <div class="instagram__text">
                  <i class="fa fa-instagram"></i>
                  <a href="#">@ ashion_shop</a>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-4 p-0">
              <div class="instagram__item set-bg" style={{ backgroundImage: `url('/theme/ashion/img/instagram/insta-5.jpg')` }} data-setbg="img/instagram/insta-5.jpg">
                <div class="instagram__text">
                  <i class="fa fa-instagram"></i>
                  <a href="#">@ ashion_shop</a>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-4 p-0">
              <div class="instagram__item set-bg" style={{ backgroundImage: `url('/theme/ashion/img/instagram/insta-6.jpg')` }} data-setbg="img/instagram/insta-6.jpg">
                <div class="instagram__text">
                  <i class="fa fa-instagram"></i>
                  <a href="#">@ ashion_shop</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <footer class="footer">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-7">
              <div class="footer__about">
                <div class="footer__logo">
                  <Link to={'/bazaar'}><img src={bazaarLogo} alt="" /></Link>
                </div>
                <p>Pargati Bazaar is a bustling and colorful marketplace that offers a unique blend of traditional charm and modern convenience.</p>
                <div class="footer__payment">
                  <a href="#"><img src="/theme/ashion/img/payment/payment-1.png" alt="" /></a>
                  <a href="#"><img src="/theme/ashion/img/payment/payment-2.png" alt="" /></a>
                  <a href="#"><img src="/theme/ashion/img/payment/payment-3.png" alt="" /></a>
                  <a href="#"><img src="/theme/ashion/img/payment/payment-4.png" alt="" /></a>
                  <a href="#"><img src="/theme/ashion/img/payment/payment-5.png" alt="" /></a>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-5">
              <div class="footer__widget">
                <h6>Quick links</h6>
                <ul>
                  <li><a href="#">About</a></li>
                  <li><a href="#">Blogs</a></li>
                  <li><a href="#">Contact</a></li>
                  <li><a href="#">FAQ</a></li>
                </ul>
              </div>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4">
              <div class="footer__widget">
                <h6>Account</h6>
                <ul>
                  <li><a href="#">My Account</a></li>
                  <li><a href="#">Orders Tracking</a></li>
                  <li><a href="#">Checkout</a></li>
                  <li><a href="#">Wishlist</a></li>
                </ul>
              </div>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-8">
              <div class="footer__newslatter">
                <h6>NEWSLETTER</h6>
                <form action="#">
                  <input type="text" placeholder="Email" />
                  <button type="submit" class="site-btn">Subscribe</button>
                </form>
                <div class="footer__social">
                  <a href="#"><i class="fa fa-facebook"></i></a>
                  <a href="#"><i class="fa fa-twitter"></i></a>
                  <a href="#"><i class="fa fa-youtube-play"></i></a>
                  <a href="#"><i class="fa fa-instagram"></i></a>
                  <a href="#"><i class="fa fa-pinterest"></i></a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="footer__copyright__text">
                <p>Copyright &copy; <script>document.write(new Date().getFullYear());</script> All rights reserved | This website is made with <i class="fa fa-heart" aria-hidden="true"></i> by <a href="https://pargationline.com/" target="_blank">Pargati Technologies</a></p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div class="search-model">
        <div class="h-100 d-flex align-items-center justify-content-center">
          <div class="search-close-switch">+</div>
          <form class="search-model-form">
            <input type="text" id="search-input" placeholder="Search here....." />
          </form>
        </div>
      </div>
      <nav class="bottom-nav">
        <Link to="/bazaar" class="nav-item">
          <FontAwesomeIcon icon={faHouse} />
          <span>Home</span>
        </Link>
        <Link to="#" class="nav-item">
          <FontAwesomeIcon icon={faLayerGroup} />
          <span>Categories</span>
        </Link>
        <Link to="/bazaar/cart" class="nav-item">
          <div className="icon-with-badge">
            <FontAwesomeIcon icon={faCartShopping} />
            <span class="badge">{cart.length}</span>
          </div>
          <span>Cart</span>
        </Link>
        <Link to="#" class="nav-item">
          <div className="icon-with-badge">
            <FontAwesomeIcon icon={faHeart} />
            <span class="badge">0</span>
          </div>
          <span>Wishlist</span>
        </Link>
        <Link to="#" class="nav-item">
          <FontAwesomeIcon icon={faUser} />
          <span>Profile</span>
        </Link>
      </nav>
      <ToastContainer />
    </>
  );
}

export default BazaarLayout;
